export default function NotFound() {
  return (
    <div>
      <h1>The page was not found </h1>
      <h2>Error 404 </h2>
    </div>
  );
}
